import React, { useState } from "react";
import { useFormikContext } from "formik";
import {
    Grid,
    Typography,
    Box,
    Button,
    Avatar,
    CircularProgress,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import { motion } from "framer-motion";

const ImageUploadStep = ({ metadata }) => {
    const { values, setFieldValue } = useFormikContext();
    const [loading, setLoading] = useState(false);

    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length === 0) return;
        const file = acceptedFiles[0];
        const reader = new FileReader();

        setLoading(true);
        reader.onloadend = () => {
            setFieldValue("image_base64", reader.result.split(",")[1]); // Guardar solo el contenido base64
            setLoading(false);
        };
        reader.readAsDataURL(file);
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: "image/*",
        onDrop,
        multiple: false,
    });

    return (
        <Grid container spacing={4}>
            <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom>
                    Subir Foto
                </Typography>
      
            </Grid>

            {/* Zona de Arrastrar y Soltar */}
            <Grid item xs={12}>
                <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    transition={{ duration: 0.2 }}
                >
                    <Box
                        {...getRootProps()}
                        sx={{
                            border: "2px dashed #ccc",
                            borderRadius: "8px",
                            padding: "16px",
                            textAlign: "center",
                            cursor: "pointer",
                            backgroundColor: "#f9f9f9",
                        }}
                    >
                        <input {...getInputProps()} />
                        {!loading ? (
                            <Typography variant="body1" color="textSecondary">
                                Arrastra y suelta la imagen aquí, o haz clic para cargarla
                            </Typography>
                        ) : (
                            <CircularProgress />
                        )}
                    </Box>
                </motion.div>
            </Grid>

            {/* Vista Previa de la Imagen */}
            {values.image_base64 && (
                <Grid item xs={12} container justifyContent="center">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        <Avatar
                            variant="square"
                            src={`data:image/jpeg;base64,${values.image_base64}`}
                            alt="Vista Previa"
                            sx={{
                                width: 350,
                                height: 350,
                                margin: "16px auto",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        />
                    </motion.div>
                </Grid>
            )}

            {/* Botón para eliminar la imagen */}
            {values.image_base64 && (
                <Grid item xs={12} container justifyContent="center">
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setFieldValue("image_base64", "")}
                    >
                        Eliminar Imagen
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};

export default ImageUploadStep;
